export const stageTotalValue = statuses =>
  statuses.reduce((acc, s) => {
    return acc + s.value
  }, 0)

export const stageTotalCount = statuses =>
  statuses.reduce((acc, s) => {
    return acc + s.count
  }, 0)

export const round2decimals = value => Math.round(value * 100) / 100
